import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import styles from './styles'
import { ICompanySettingsTabs, ECompanySettingsTabs } from 'models'

const useStyles = makeStyles(styles)

interface ISectionsList {
	tabsObj: ICompanySettingsTabs
	hasCurrentUserAdminPermission: boolean
	hasCurrentUserManagerPermission: boolean
	hasCurrentUserPublisherPermission: boolean
	storeUserIg: boolean
	setTab: Function
	currentTabIndex: string
}

const SectionsList: React.FunctionComponent<ISectionsList> = ({
	tabsObj,
	hasCurrentUserAdminPermission,
	hasCurrentUserManagerPermission,
	hasCurrentUserPublisherPermission,
	storeUserIg,
	setTab,
	currentTabIndex,
}) => {
	const { t } = useTranslation()
	const classes = useStyles()

	return (
		<div className={classes.container}>
			<FormControl variant="outlined">
				<InputLabel id="sectionsListLabelId">{t('Section')}</InputLabel>
				<Select
					labelId="sectionsListLabelId"
					value={currentTabIndex}
					label={t('Section')}
					className={classes.select}
				>
					{Object.keys(tabsObj)
						?.filter(item => {
							if (storeUserIg || hasCurrentUserAdminPermission) {
								return true
							} else if (
								hasCurrentUserManagerPermission &&
								item !== ECompanySettingsTabs.UserAccounts
							) {
								return true
							} else if (
								hasCurrentUserPublisherPermission &&
								item === ECompanySettingsTabs.Jobs
							) {
								return true
							} else {
								return false
							}
						})
						?.map((tab: any, index: number) => {
							return (
								<MenuItem key={`tab-${index}`} value={tab}>
									<Grid
										item={true}
										onClick={setTab(tab)}
										className={classes.selectItemSpan}
									>
										<span>
											{
												// @ts-ignore
												tabsObj[tab]
											}
										</span>
									</Grid>
								</MenuItem>
							)
						})}
				</Select>
			</FormControl>
		</div>
	)
}

export default SectionsList
